export enum TimeslotType {
    Loading = 0,
    Delivery = 1,
    Unknown = 2
}


